'use strict';
const axios = require("axios");

function request(config) {
    this.apiUrl1 = "";
    this.apiUrl2 = "";
    this.apiUrl3 = "";
    this.apiUrl4 = "";
    this.token = null;
    this.storeID = 0;
    this.settings = {};
    this.defSettings = {
        "url": "",
        "method": "GET",
        "timeout": 0,
    };

    this.apiUrl1 = config.api[0];
    this.apiUrl2 = config.api[1];
    this.apiUrl3 = config.api[2];
    this.apiUrl4 = config.api[3];
    this.token = "Bearer " + config.token;
    this.storeID = config.storeID;

    this.test = function () {
        axios({
            method: 'get',
            url: 'http://10.10.9.194:3000/test',
            timeout: 120000  // Tiempo de espera de 10 segundos
        })
        .then(function (response) {
            alert(response.data);
        })
        .catch(function (error) {
            let errorMessage = "Error: ";
            if (error.request) {
                errorMessage += "Request made, but no response received";
            } else {
                errorMessage += error.message;
            }
            alert(errorMessage);
        });
    };

    this.jsonRequest = function (req, url = null, camps = null) {

			this.settings = {};
	
			switch (req) {
				case "lastServerByTableNumber":
					this.settings = {...this.defSettings};
					this.settings["method"] = "GET";
					this.settings["headers"] = { 
						"Content-Type": "application/json", 
					};
					this.settings["url"] = this.apiUrl1 + "order/server/lastServerByTableNumber/" + camps[0];
					break;
				case "printTurn":
					this.settings = {...this.defSettings};
					this.settings["method"] = "POST";
					this.settings["headers"] = { 
						"Content-Type": "multipart/form-data", 
					};
					this.settings["data"] = camps;
					this.settings["url"] = url+ '/printTurn';
					break;
				case "getCategories":
					this.settings = {...this.defSettings};
					this.settings["method"] = "GET";
					this.settings["url"] = this.apiUrl3 + "Menu";
					this.settings["headers"] = { 
						"Content-Type": "application/json", 
						"Authorization": this.token,
						"x-storenumber": this.storeID,
						"x-place":"restaurant"
					};
					break;
				case "getItems":
					this.settings = {...this.defSettings};
					this.settings["method"] = "GET";
					this.settings["url"] = this.apiUrl3 + "Categorie/"+camps[0];
					this.settings["headers"] = { 
						"Content-Type": "application/json", 
						"Authorization": this.token,
						"x-storenumber": this.storeID,
						"x-place":"restaurant"
					};
					break;
				case "getCategoriesInCallcenter":
					this.settings = {...this.defSettings};
					this.settings["method"] = "GET";
					this.settings["url"] = this.apiUrl3 + "Menu";
					this.settings["headers"] = { "x-storenumber":camps.storeId, "x-place":"cc"};
					break;
				case "getItemsInCallcenter":
					this.settings = {...this.defSettings};
					this.settings["method"] = "GET";
					this.settings["url"] = this.apiUrl3 + "Categorie/"+camps.category;
					this.settings["headers"] = { "x-storenumber":camps.storeId, "x-place":"cc"};
					break;
				case "getOptions":
					this.settings = {...this.defSettings};
					this.settings["method"] = "GET";
					this.settings["url"] = this.apiUrl3 + "Product/"+camps[0];
					this.settings["headers"] = { 
						"Content-Type": "application/json", 
						"Authorization": this.token,
						"x-storenumber": camps[2],
						"x-place": camps[1]
					};
					break;
				case "makeOrderInCallcenter":
					this.settings["method"] = "POST";
					this.settings["url"] = this.apiUrl2 + "index.php/EfisenseHub/Order/create";
					this.settings["headers"] = { 
						"Content-Type": "application/json", 
						"Authorization": this.token,
						"x-place":"cc"
					};
					this.settings["data"] = JSON.stringify(camps.orden);
					break;
				case "sendOrder":
					this.settings = {...this.defSettings};
					this.settings["method"] = "POST";
					this.settings["url"] = this.apiUrl2 + "index.php/EfisenseHub/Order/create";
					this.settings["headers"] = { 
						"Content-Type": "application/json", 
						"Authorization": this.token,
					};
					this.settings["data"] = JSON.stringify(camps[0]);
					break;
				case "addToQueue":
					this.settings = {...this.defSettings};
					this.settings["method"] = "POST";
					this.settings["headers"] = { 
						"Content-Type": "application/json", 
						"Authorization": this.token
					};
					this.settings["data"] = JSON.stringify(camps);
					this.settings["url"] = this.apiUrl4 + "Appointment/create";
					break;
				case "getQueueList":
					this.settings = {...this.defSettings};
					this.settings["method"] = "POST";
					this.settings["headers"] = { 
						"Content-Type": "application/json", 
						"Authorization": this.token
					};
					this.settings["data"] = JSON.stringify(camps);
					this.settings["url"] = this.apiUrl4 + "Appointment/index";
					break;
				case "newPerson":
					this.settings = {...this.defSettings};
					this.settings["method"] = "POST";
					this.settings["headers"] = { 
						"Content-Type": "application/json", 
						"Authorization": this.token
					};
					this.settings["data"] = JSON.stringify(camps);
					this.settings["url"] = this.apiUrl4 + "Patient";
					break;
				case "getPersons":
					this.settings = {...this.defSettings};
					this.settings["method"] = "POST";
					this.settings["headers"] = { 
						"Content-Type": "application/json", 
						"Authorization": this.token
					};
					this.settings["data"] = JSON.stringify(camps);
					this.settings["url"] = this.apiUrl4 + "Patient/index";
					break;
				case "updatePerson":
					this.settings = {...this.defSettings};
					this.settings["method"] = "PUT";
					this.settings["headers"] = { 
						"Content-Type": "application/json", 
						"Authorization": this.token
					};
					this.settings["data"] = JSON.stringify(camps[0]);
					this.settings["url"] = this.apiUrl4 + "Patient/"+camps[1];
					break;
				case "getHistory":
					this.settings = {...this.defSettings};
					this.settings["method"] = "GET";
					this.settings["headers"] = { 
						"Content-Type": "application/json", 
						"Authorization": this.token
					};
					this.settings["url"] = this.apiUrl4 + "Appointment/history/"+camps[0];
					break;
				case "matchData":
					this.settings = {...this.defSettings};
					this.settings["method"] = "GET";
					this.settings["url"] = this.apiUrl1 + "order/server/index/"+camps[0];
					break;
				case "getTableItems":
					this.settings = {...this.defSettings};
					this.settings["method"] = "GET";
					this.settings["url"] = this.apiUrl1 + "order/ticket/index/"+camps[0]+"/"+camps[2]+"/"+camps[1];
					this.settings["headers"] = {};
					break
				case "getAccounts":
					this.settings = {...this.defSettings};
					this.settings["method"] = "GET";
					this.settings["url"] = this.apiUrl3 + "Login/" + String(camps.number);
					break;
				case "getAccountData":
					this.settings["method"] = "POST";
					this.settings["url"] = this.apiUrl3 + "Login";
					this.settings["headers"] = { "Content-Type": "application/json" };
					this.settings["data"] = JSON.stringify({"idClient":camps.id});
					break;
				case "getStore":
					this.settings = {...this.defSettings};
					this.settings["method"] = "GET";
					this.settings["headers"] = { 
						"Content-Type": "application/json", 
						"Authorization": this.token
					};
					this.settings["url"] = this.apiUrl3 + "Brand";
					break;
				case "getStates":
					this.settings = {...this.defSettings};
					this.settings["method"] = "GET";
					this.settings["url"] = this.apiUrl3 + "ubication/state";
					break;
				case "getTowns":
					this.settings = {...this.defSettings};
					this.settings["method"] = "GET";
					this.settings["url"] = this.apiUrl3 + "ubication/town/"+String(camps.stateN);
					break;
				case "getColonies":
					this.settings = {...this.defSettings};
					this.settings["method"] = "GET";
					this.settings["url"] = this.apiUrl3 + "ubication/colonie/"+camps.stateNumber+"/"+camps.townNumber+"/"+camps.colony;
					break;
				case "checkService":
					this.settings = {...this.defSettings};
					this.settings["method"] = "GET";
					this.settings["url"] = this.apiUrl3 + "ubication/checkService/"+String(camps.parseUrl);
					break;
				case "editAccountProfile":
					this.settings = {...this.defSettings};
					this.settings["method"] = "PUT";
					this.settings["url"] = this.apiUrl3 + "Client/update";
					this.settings["headers"] = { 
						"Content-Type": "application/json", 
						"Authorization": "Bearer " + camps.key
					};
					this.settings["data"] = JSON.stringify(camps.account);
					break;
				case "editAccountDirecction":
					this.settings = {...this.defSettings};
					this.settings["method"] = "PUT";
					this.settings["url"] = this.apiUrl3 + "Address/update";
					this.settings["headers"] = { 
						"Content-Type": "application/json", 
						"Authorization": "Bearer " + camps.key
					};
					this.settings["data"] = JSON.stringify(camps.account);
							break;
				case "createAccount":
					this.settings = {...this.defSettings};
					this.settings["method"] = "POST";
					this.settings["url"] = this.apiUrl3 + "Client";
					this.settings["headers"] = { "Content-Type": "application/json" };
					this.settings["data"] = JSON.stringify(camps.account);
					break;
				case "getListOrders":
					this.settings = {...this.defSettings};
					this.settings["method"] = "POST";
					this.settings["url"] = this.apiUrl2 + "index.php/EfisenseHub/Order/index";
					this.settings["headers"] = { 
						"Content-Type": "application/json", 
						"Authorization": this.token,
					};
					this.settings["data"] = JSON.stringify(camps);
					break;
				case "acceptOrder":
					this.settings = {...this.defSettings};
					this.settings["headers"] = { 
						"Content-Type": "application/json", 
						"Authorization": this.token,
					};
					this.settings["method"] = "POST";
					this.settings["url"] = this.apiUrl2 + "index.php/EfisenseHub/OrderProcess/Accept/" + camps;
					break;
				case "getOrder":
					this.settings = {...this.defSettings};
					this.settings["headers"] = { 
						"Content-Type": "application/json", 
						"Authorization": this.token,
					};
					this.settings["method"] = "GET";
					this.settings["url"] = this.apiUrl2 + "index.php/EfisenseHub/Order/" + camps;
					break;
				case "changeOrderStatus":
					this.settings = {...this.defSettings};
					this.settings["headers"] = { 
						"Content-Type": "application/json", 
						"Authorization": this.token,
					};
					this.settings["method"] = "PUT";
					this.settings["data"] = JSON.stringify({'status':camps.status});
					this.settings["url"] = this.apiUrl2 + "index.php/EfisenseHub/Order/"+camps.id;
					break;
				case "getStoreHub":
					this.settings = {...this.defSettings};
					this.settings["headers"] = { 
						"Content-Type": "application/json", 
						"Authorization": this.token,
					};
					this.settings["method"] = "GET";
					this.settings["url"] = this.apiUrl2 + "index.php/EfisenseHub/Store";
					break;
				case "getTicketXML":
					this.settings = {...this.defSettings};
					this.settings["headers"] = { 
						"Content-Type": "application/json", 
						"Authorization": this.token,
					};
					this.settings["method"] = "POST";
					this.settings["url"] = this.apiUrl2 + "index.php/Billing/Ticket/show/"+camps+"/xml";
					break;
				case "getVersions":
					this.settings = {...this.defSettings};
					this.settings["method"] = "GET";
					this.settings["url"] = this.apiUrl4 + "/version";
					break;
				case "getTeamUsers":
					this.settings = {...this.defSettings};
					this.settings["method"] = "GET";
					this.settings["headers"] = { 
						"Content-Type": "application/json", 
						"Authorization": this.token,
					};
					this.settings["url"] = this.apiUrl2 + "Staff/Employee/list";
					break;
				case "setProfilePhoto":
					this.settings = {...this.defSettings};
					this.settings["method"] = "POST";
					this.settings["url"] = this.apiUrl2 + "Staff/Employee/uploadAvatar";
					this.settings["headers"] = { 
						'Content-Type': "multipart/form-data",
						'Authorization': this.token
					}
					this.settings["data"] = camps;
					break;
				case "sendPhoneCode":
					this.settings = {...this.defSettings};
					this.settings["method"] = "POST";
					this.settings["url"] = this.apiUrl2 + "Staff/Employee/requireCode";
					this.settings["headers"] = { 
						'Content-Type': "application/json",
						'Authorization': this.token
					}
					this.settings["data"] = JSON.stringify(camps);
					break;
				case "sendPhoneCode":
					this.settings = {...this.defSettings};
					this.settings["method"] = "POST";
					this.settings["url"] = this.apiUrl2 + "Staff/Employee/requireCode";
					this.settings["headers"] = { 
						'Content-Type': "application/json",
						'Authorization': this.token
					}
					this.settings["data"] = JSON.stringify(camps);
					break;
				case "matchCodePhone":
					this.settings = {...this.defSettings};
					this.settings["method"] = "POST";
					this.settings["url"] = this.apiUrl2 + "Staff/Employee/confirmCode";
					this.settings["headers"] = { 
						"Content-Type": "application/json",
						'Authorization': this.token
					}
					this.settings["data"] = JSON.stringify(camps);
					break;
				case "sendManagerCode":
					this.settings = {...this.defSettings};
					this.settings["method"] = "POST";
					this.settings["url"] = this.apiUrl2 + "Staff/Manager/notify";
					this.settings["headers"] = { 
						'Authorization': this.token
					}
					break;
				case "matchCodeManager":
					this.settings = {...this.defSettings};
					this.settings["method"] = "POST";
					this.settings["url"] = this.apiUrl2 + "Staff/Manager/confirmCode";
					this.settings["headers"] = { 
						"Content-Type": "application/json",
						'Authorization': this.token
					}
					this.settings["data"] = JSON.stringify(camps);
					break;
				case "getOnlineServers":
					this.settings = {...this.defSettings};
					this.settings["method"] = "GET";
					this.settings["url"] = this.apiUrl1 + "order/server/all";
					break;
	
				case "saveUserData":
					this.settings = {...this.defSettings};
					this.settings["method"] = "PUT";
					this.settings["url"] = this.apiUrl2 + "Staff/Employee/"+camps.id;
					this.settings["headers"] = { 
						"Content-Type": "application/json", 
						"Authorization": this.token
					};
					this.settings["data"] = JSON.stringify(camps.data);
					break;
				case "generateNewCard":
					this.settings = {...this.defSettings};
					this.settings["method"] = "PUT";
					this.settings["url"] = this.apiUrl2 + "Staff/Card/"+camps.id;
					this.settings["headers"] = { 
						"Content-Type": "application/json", 
						"Authorization": this.token
					};
					this.settings["data"] = JSON.stringify(camps.data);
					break;
				case "getQRreward":
					this.settings = {...this.defSettings};
					this.settings["method"] = "GET";
					this.settings["url"] = this.apiUrl2 + "/EfisenseHub/v2/Admin/QRreward/"+camps.id;
					this.settings["headers"] = { 
						"Content-Type": "application/json", 
						"Authorization": this.token
					};
					break;
				case "chargeAmountGiftCard":
					this.settings = {...this.defSettings};
					this.settings["method"] = "POST";
					this.settings["url"] = this.apiUrl2 + "/EfisenseHub/v2/Admin/GiftCard/Charge/"+camps.id;
					this.settings["headers"] = { 
						"Content-Type": "application/json", 
						"Authorization": this.token
					};
					this.settings["data"] = JSON.stringify(camps.data);
					break;
				case "processGiftCard":
					this.settings = {...this.defSettings};
					this.settings["method"] = "PUT";
					this.settings["url"] = this.apiUrl2 + "/EfisenseHub/v2/Admin/GiftCard/"+camps.id;
					this.settings["headers"] = { 
						"Content-Type": "application/json", 
						"Authorization": this.token
					};
					break;
				case "getTickets":
					this.settings = {...this.defSettings};
					this.settings["method"] = "GET";
					this.settings["url"] = this.apiUrl1 + "order/ticket/ticketByTable/"+camps.table;
					break;
				case "resendWhatsApp":
					this.settings = {...this.defSettings};
					this.settings["method"] = "POST";
					this.settings["headers"] = { 
						"Content-Type": "application/json", 
						"Authorization": this.token
					};
					this.settings["data"] = JSON.stringify(camps);
					this.settings["url"] = this.apiUrl4 + "Patient/resendWA";
					break;
				default:
					return false
			}
			return this.settings
	};

	this.resendWhatsApp = function (data = {}) {
		let json = this.jsonRequest("resendWhatsApp", '', data);
		return this.petition(json, false)
	}

	this.getTickets = function (data = {}) {
		let json = this.jsonRequest("getTickets", '', data);
		return this.petition(json, false)
	}

	this.printTurn = function (tvip, data = {}) {
		let json = this.jsonRequest("printTurn", tvip, data);
		return this.petition(json, false)
	}

	this.getVersions = function () {
		let json = this.jsonRequest("getVersions", null, null);
		return this.petition(json, false)
	}
	this.getTicketXML = function (data = {}) {
		let json = this.jsonRequest("getTicketXML", null, data);
		return this.petition(json, false)
	}
	this.getOrder = function (data = {}) {
		let json = this.jsonRequest("getOrder", null, data);
		return this.petition(json, false)
	}
	this.getStoreHub = function (data = {}) {
		let json = this.jsonRequest("getStoreHub", null, data);
		return this.petition(json, false)
	}
	this.acceptOrder = function (data = {}) {
		let json = this.jsonRequest("acceptOrder", null, data);
		return this.petition(json, false)
	}
	this.changeOrderStatus = function (data = {}) {
		let json = this.jsonRequest("changeOrderStatus", null, data);
		return this.petition(json, false)
	}
	this.getListOrders = function (data = {}) {
		let json = this.jsonRequest("getListOrders", null, data);
		return this.petition(json, false)
	}
	this.checkService = function (data = "") {
		let json = this.jsonRequest("checkService", null, data);
		return this.petition(json, false)
	}
	this.editAccountProfile = function (data = "") {
		let json = this.jsonRequest("editAccountProfile", null, data);
		return this.petition(json, false)
	}
	this.editAccountDirecction = function (data = "") {
		let json = this.jsonRequest("editAccountDirecction", null, data);
		return this.petition(json, false)
	}
	this.createAccount = function (data = "") {
		let json = this.jsonRequest("createAccount", null, data);
		return this.petition(json, false)
	}
	this.getStore = function () {
		let json = this.jsonRequest("getStore", null, null);
		return this.petition(json, false)
	}
	this.getStates = function () {
		let json = this.jsonRequest("getStates", null, null);
		return this.petition(json, false)
	}
	this.getTowns = function (data = "") {
		let json = this.jsonRequest("getTowns", null, data);
		return this.petition(json, false)
	}
	this.getColonies = function (data = "") {
		let json = this.jsonRequest("getColonies", null, data);
		return this.petition(json, false)
	}
	this.getAccountData = function (data = "") {
		let json = this.jsonRequest("getAccountData", null, data);
		return this.petition(json, false)
	}
	this.getAccounts = function (data = "") {
		let json = this.jsonRequest("getAccounts", null, data);
		return this.petition(json, false)
	}
	this.getCategories = function (type="Fraccionamiento", col="kukulcan", zip="97198", storeID=false) {
		let json = this.jsonRequest("getCategories", null, [col, type, zip, storeID]);
		return this.petition(json)
	}
	this.getItemsInCategory = function (cat = "") {
		let json = this.jsonRequest("getItems", null, [cat]);
		return this.petition(json)
	}
	this.getCategoriesInCallcenter = function (data = "") {
		let json = this.jsonRequest("getCategoriesInCallcenter", null, data);
		return this.petition(json)
	}
	this.getItemsInCallcenter = function (data = "") {
		let json = this.jsonRequest("getItemsInCallcenter", null, data);
		return this.petition(json)
	}
	this.getOptions = function (itemId = []) {
		let json = this.jsonRequest("getOptions", null, itemId);
		return this.petition(json)
	}
	this.makeOrderInCallcenter = function (data = "") {
		let json = this.jsonRequest("makeOrderInCallcenter", null, data);
		return this.petition(json, false)
	}
	this.sendOrder = function (order = {}) {
		let json = this.jsonRequest("sendOrder", null, [order]);
		return this.petition(json)
	}
	this.matchData = function (code = "") {
		let json = this.jsonRequest("matchData", null, [code]);
		return this.petition(json)
	}
	this.newPerson = function (payload = "") {
		let json = this.jsonRequest("newPerson", null, payload);
		return this.petition(json)
	}
	this.getPersons = function (payload = "") {
		let json = this.jsonRequest("getPersons", null, payload);
		return this.petition(json)
	}
	this.getHistory = function (id = "") {
		let json = this.jsonRequest("getHistory", null, [id]);
		return this.petition(json)
	}
	this.updatePerson = function (payload = "", id) {
		let json = this.jsonRequest("updatePerson", null, [payload, id]);
		return this.petition(json)
	}
	this.getQueueList = function (payload = "") {
		let json = this.jsonRequest("getQueueList", null, payload);
		return this.petition(json)
	}
	this.addToQueue = function (payload = "") {
		let json = this.jsonRequest("addToQueue", null, payload);
		return this.petition(json)
	}
	this.getTableItems = function (code = "", tableNumb = 0, ticketNum = 0) {
		let json = this.jsonRequest("getTableItems", null, [code, tableNumb, ticketNum]);
		return this.petition(json)
	}
	this.getTeamUsers = function (data = []){
		let json = this.jsonRequest("getTeamUsers", null, data);
		return this.petition(json)
	}
	this.setProfilePhoto = function (data = []){
		let json = this.jsonRequest("setProfilePhoto", null, data);
		return this.petition(json)
	}
	this.sendPhoneCode = function (data = {}){
		let json = this.jsonRequest("sendPhoneCode", null, data);
		return this.petition(json)
	}
	this.matchCodePhone = function (data = {}) {
		let json = this.jsonRequest("matchCodePhone", null, data);
		return this.petition(json, false)
	}
	this.sendManagerCode = function (){
		let json = this.jsonRequest("sendManagerCode", null, null);
		return this.petition(json)
	}
	this.matchCodeManager = function (data = {}) {
		let json = this.jsonRequest("matchCodeManager",null, data);
		return this.petition(json, false)
	}
	this.getOnlineServers = function () {
		let json = this.jsonRequest("getOnlineServers", null, null);
		return this.petition(json)
	}
	this.lastServerByTableNumber = function (tableNumber = "") {
		let json = this.jsonRequest("lastServerByTableNumber", null, [tableNumber]);
		return this.petition(json)
	}
	this.saveUserData = function (data = {}) {
		let json = this.jsonRequest("saveUserData", null, data);
		return this.petition(json)
	}
	this.generateNewCard = function (data = {}) {
		let json = this.jsonRequest("generateNewCard", null, data);
		return this.petition(json)
	}
	this.getQRreward = function (data = {}) {
		let json = this.jsonRequest("getQRreward", null, data);
		return this.petition(json)
	}
	this.chargeAmountGiftCard = function (data = {}) {
		let json = this.jsonRequest("chargeAmountGiftCard", null, data);
		return this.petition(json)
	}
	this.processGiftCard = function (data = {}) {
		let json = this.jsonRequest("processGiftCard", null, data);
		return this.petition(json)
	}

    this.petition = async function (json, watch = true) {
        return new Promise(function(resolve, reject) {
            if (json) {
                axios(json)
                    .then(function (response) {
                        resolve(response.data);
                    })
                    .catch(function (error) {
                        let response = {data: false, code: 500, msj: JSON.stringify(error)};
                        if (watch) {
                            console.log('[error/api]', error);
                        }
                        reject(response);
                    });
            } else {
                let response = {data: false, code: 500};
                resolve(response);
            }
        });
    };
}

module.exports = {
    request
};
